import type { ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button, EmptyState } from "@/shared/ui";

/** The router's default `errorComponent` — every route gets a recoverable error state. */
export function RouteError({ reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t("errors.somethingWentWrong")}
      description={t("errors.unexpectedError")}
      action={
        <Button variant="ghost" onClick={reset}>
          {t("errors.tryAgain")}
        </Button>
      }
    />
  );
}
